import { Form, Formik, FormikHelpers } from "formik";
import { brandCreationDTO } from "./brand.model";
import * as Yup from "yup";
import TextField from "../forms/TextField";
import Button from "../utils/Button";
import { Link } from "react-router-dom";

export default function BrandForm(props: brandFormProps) {
  return (
    <Formik
      initialValues={props.model}
      onSubmit={props.onSubmit}
      validationSchema={Yup.object({
        name: Yup.string()
          .required("This field is required")
          .firstLetterUppercase(),
      })}
    >
      {(formikProps) => (
        <Form
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <TextField field="name" displayName="Name" />

          <Button disabled={formikProps.isSubmitting} type="submit">
            Save Changes
          </Button>

          <Link className="btn btn-primary" to="/categories">
            Cancel
          </Link>
        </Form>
      )}
    </Formik>
  );
}

interface brandFormProps {
  model: brandCreationDTO;
  onSubmit(
    values: brandCreationDTO,
    action: FormikHelpers<brandCreationDTO>
  ): void;
}
